var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5556 2.44444H7.93333C5.50644 2.44444 4.29299 2.44444 3.36604 2.91675C2.55067 3.3322 1.88776 3.99512 1.47231 4.81049C1 5.73744 1 6.95088 1 9.37778V20.0667C1 22.4936 1 23.707 1.47231 24.634C1.88776 25.4493 2.55067 26.1122 3.36604 26.5277C4.29299 27 5.50644 27 7.93333 27H18.6222C21.0491 27 22.2626 27 23.1895 26.5277C24.0049 26.1122 24.6678 25.4493 25.0832 24.634C25.5556 23.707 25.5556 22.4936 25.5556 20.0667V15.4444M15.4444 21.2222H6.77778M18.3333 15.4444H6.77778M25.7308 2.2692C27.4231 3.96148 27.4231 6.70519 25.7308 8.39746C24.0385 10.0897 21.2948 10.0897 19.6025 8.39746C17.9103 6.70519 17.9103 3.96148 19.6025 2.2692C21.2948 0.576932 24.0385 0.576932 25.7308 2.2692Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.b81c13d0296fb1c8216a666b19e8746d.svg";
export { ForwardRef as ReactComponent };